<template>
  <button
    :class="[
      'button',
      `button_${type}`,
      { 'button_disabled': disabled },
      { 'button_loading': isLoading }
    ]"
    :type="tagType"
    @click="onClick"
  >
    <span class="button__text">
      <slot />
    </span>
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',
    props: {
      tagType: { // html type attr
        type: String,
        default: 'button'
      },
      type: {
        type: String,
        default: 'main',
        validator (type) {
          return type === 'main' ||
            type === 'secondary'
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick () {
        if (this.disabled) return
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss">
  .button {
    position: relative;
    text-align: center;
    cursor: pointer;
    border: none;
    border-radius: 3em;
    outline: none;
    transition: 0.3s;
    transform-origin: 50% 50%;

    &:active {
      transform: scale(0.95);
    }

    &_main {
      padding: 1em 2.5em;
      font-size: 16px;
      line-height: 1;
      color: $c-white;
      background-color: $c-active-light;

      @include hover {
        background-color: $c-active;
      }
    }

    &_secondary {
      padding: 0.8em 2.75em;
      font-size: 14px;
      color: $c-black;
      background-color: $c-gray-light;

      @include hover {
        background-color: $c-gray;
      }
    }

    &__text {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 15px;
      color: inherit;
      transition: 0.4s;
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    // spinner
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: 1em;
      height: 1em;
      content: '';
      border: 2px solid white;
      border-left-color: transparent;
      border-radius: 50%;
      opacity: 0;
      transition: opacity 0.4s;
      transform: translate(-50%, -50%);
    }

    @keyframes spin {
      100% {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }

    &_loading {
      pointer-events: none;

      .button__text {
        opacity: 0;
      }

      &::before {
        opacity: 1;
        animation: spin 0.7s infinite;
      }
    }
  }
</style>
